import close from '../../assets/icon/close.png'
import dArrow from '../../assets/icon/darrow_w.png'
import uArrow from '../../assets/icon/uparrow_w.png'

import lArrow from '../../assets/ALeft.png'
import rArrow from '../../assets/ARight.png'
import { useEffect, useMemo, useState } from 'react'

function Emb_modal({hoverDetils,setHoverDets }) {

    const [hDes, setHdes] = useState(true)
    const [himg, setHimg] = useState(0)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 480);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(()=>{
        console.log(hoverDetils)
    }, [hoverDetils])

    return ( 
        <div className="s-modal"
            style={{"backgroundColor":"white"}}
        >
            {/* <div style={{"position":"relative", "width":"100%", "height":"100%", "backgroundColor":"white", "z-index":"1000"}}></div> */}
            <div
                onClick={()=>{
                    setHdes(true)
                    setHimg(0)
                    setHoverDets(null)
                }}
            >
            
            <img 
                type="button"
            src={close} style={{right:"15px", "top":"15px", position:"absolute", "zIndex":"1", "width":"40px"}}/>
            
            </div>
        
            
            {himg === 0 ? 
                (<img 
                    // onLoad={imageLoaded}
                    src={hoverDetils['single'][0]} className="m-main-img"/>)
            : (
                <img 
                // onLoad={imageLoaded}
                src={himg === 1 ? hoverDetils['src'] : hoverDetils['single'][himg-1]} className="m-main-img"/>
            )
            }

            <img  src={lArrow} className="m-f-img-l"
                onClick={()=>{

                    if(himg>0){
                        // console.log("left click")
                        setHimg(himg-1)
                    }
                }}
            />
            <img src={rArrow}  className="m-f-img-r"
                onClick={()=>{
                    if(himg < hoverDetils['single'].length){
                        // console.log("Right click")
                        setHimg(himg+1)
                    }
                }}
            />
            
            <div className="s-hoverDes">
                <img src={hDes ? `${dArrow}` : `${uArrow}`} className="m-f-arrow hori_center"
                    onClick={()=>{setHdes(!hDes)}}
                />
                {(hDes) ? (<>
                <div className="s-h-container">
                <div className="s-h-des-1 hori_center">
                    <label className="txt-font">{hoverDetils["name"]}</label>
                    <label className="txt-font">Machine Made</label>
                    {/* <img src={hoverDetils.brandImg} className="s-f-des-img hori_center" /> */}
                    
                    <br/>

                    <label className="txt-small">{hoverDetils["description"]}</label>  
                    
                </div>
                </div>
                </>): (
                <div>
                    
                    <b>{hoverDetils["name"]} </b>
                </div>) }
            </div>
        </div>
     );
}

export default Emb_modal;